<template>
    <div class="container">
        <h2>{{ title }}</h2>
        <ul>
            <li class="content" v-for="card in state.feedbackCards">
                <Card :class="{ highlight: card.chosen }"
                    :description="card.description"
                    @click="toggleCardChoice(card)"/>
            </li>
        </ul>
        <div class="buttonContainer">
            <button @click="goBack">Takaisin</button>
            <button @click="saveChoices">Lukitse valinnat</button>
        </div>
    </div>
</template>

<script>
import { reactive } from 'vue';
import Card from './Card.vue';
import decks from '../decks.json';

export default {
    name: 'FeedbackCards',
    props: {
        title: String,
    },
    components: {
        Card
    },
    setup(props, { emit }) {
        localStorage.setItem('feedbackCards', JSON.stringify(decks[0].cards) );
        const state = reactive({ feedbackCards: JSON.parse(localStorage.getItem('feedbackCards')) });

        const toggleCardChoice = (card) => {

            /**
             * Sets the parameter card's chosen property to true in feedbackCards array if
             * there is no chosen property. If it exists, delete chosen property.
             * The right card from the feedbackCards array is found using parameter card's id.
             * 
             * There can be maximum amount of 3 chosen cards so if the parameter card is not
             * currently chosen and already 3 other cards have chosen property set, doesn't
             * set the parameter card's chosen value.
             */
            const feedbackCards = JSON.parse(localStorage.getItem('feedbackCards'));
            const currentCardIndex = feedbackCards.findIndex(cardInArray => cardInArray.id === card.id);

            if (feedbackCards[currentCardIndex].chosen)
                delete feedbackCards[currentCardIndex].chosen;
            else if (!feedbackCards[currentCardIndex].chosen) {
                let chosenCardsCount = 0;

                feedbackCards.forEach(card => {
                    if (card.chosen)
                        chosenCardsCount++;
                });

                if (chosenCardsCount === 3)
                    return null;
                else
                    feedbackCards[currentCardIndex].chosen = true;
            }
            localStorage.setItem('feedbackCards', JSON.stringify(feedbackCards));
            state.feedbackCards = JSON.parse(localStorage.getItem('feedbackCards'));
        }

        const goBack = () => {
            emit('goBack');
        }

        const saveChoices = () => {
            emit('nextProgress');
        }


        return { toggleCardChoice, state, goBack, saveChoices };
    },
    emits: ['goBack', 'nextProgress'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*h3 {
  margin: 40px 0 0;
}*/

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: var(--link_color);
}

.highlight {
    filter: brightness(50%);
    box-shadow: 0px 10px 5px -5px rgba(0,0,0,0.75);
    transition: filter 300ms ease-in-out;
}

.buttonContainer {
    margin: 20px 0;
}

.content div {
    cursor: pointer;
}

ul {
    height: 70vh;
    overflow-y: scroll;
}
</style>
